<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <create-mart-partner [showCreateMartSideBar]="showCreateMartSideBar"
                         *ngIf="showCreateMartSideBar"
                         [_menuHomeEnumActive]="menuHomeEnumActive"
                         [martOnboardingComponent]="this"
                         (changedShowCreateMartSideBarEmit)="changedShowCreateMartSideBarEmit($event)"></create-mart-partner>

    <detail-mart-partner [_showDetailMartPartnerSideBar]="showDetailMartPartnerSideBar" *ngIf="showDetailMartPartnerSideBar"
                         [martOnboardingComponent]="this" [_merchantId]="merchantId"
                         (changedShowDetailMartPartnerSideBarEmit)="changedShowDetailMartPartnerSideBarEmit($event)"></detail-mart-partner>

    <approve-docs-mart-partner [merchant]="selectedMerchant" *ngIf="showApproveMartPartner" [onHide]="handleApproveDocsPopupHide"></approve-docs-mart-partner>

    <review-partner-info [_showReviewPartnerInfoSideBar]="showReviewPartnerInfoSideBar" *ngIf="showReviewPartnerInfoSideBar"
                         [_merchantId]="merchantId"
                         (changedShowReviewPartnerInfoSideBarEmit)="changedShowReviewPartnerInfoSideBarEmit($event)"></review-partner-info>

    <suspend-partner *ngIf="showSuspendPartnerPopup" [merchant]="selectedMerchant" [_displayModalSuspend]="showSuspendPartnerPopup" (changedDisplayModalSuspendEmit)="changedDisplayModalSuspendEmit($event)"></suspend-partner>

    <chat *ngIf="showChatSideBar"
          [_showChatSideBar]="showChatSideBar"
          [_merchantId]="merchantId"
          [_chatId]="chatId"
          [_messageTypeId]="chatMessageTypeEnum.SupportToMerchant"
          (changedShowChatSideBarEmit)="changedShowChatSideBarEmit($event)"></chat>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="mart-onboarding-body">
        <!-- Table -->
        <p-table #xpressUsersGrid
                 [columns]="cols"
                 [value]="merchants"
                 [lazy]="true"
                 responsiveLayout="scroll" dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [loading]="loading">
            <ng-template pTemplate="caption">
                <div>
                    <p-tabMenu class="mb-5" [model]="menuItems" [activeItem]="menuItems[partnerActiveTab]"></p-tabMenu>
                    <div class="partner-onboarding-header">
                        <div class="title-float-left">
                            <div class="onboarding-head-title">
                                {{tableName}}
                            </div>
                        </div>
                        <span class="filters-panel-item flex">
                            <button pButton pRipple type="button" label="Create"
                                    class="mr-10 filters-panel-item-button p-button-success"
                                    (click)="openCreateMartPartnerSideBar()"></button>
                        </span>
                        <span class="filters-panel-item p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" class="search-input"
                                   [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                                   placeholder="Search here..." />
                        </span>
                    </div>
                </div>
                <div class="flex flex-row sp-header"></div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
                    </th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-merchant>
                <tr>
                    <td class="ui-resizable-column" *ngFor="let item of cols">
                        <ng-container [ngSwitch]="item.field">

                            <ng-container *ngSwitchCase="'StatusText'">
                                <td [class]="'ui-resizable-column td-column-center'">
                                    <span [class]="merchant.Status | getMerchantStatusBackgroundColor">{{merchant.StatusText}}</span>
                                </td>
                            </ng-container>

                            <ng-container *ngSwitchCase="'LastActive'">
                                <td class="ui-resizable-column">
                                    <span [class]="'status-' + merchant.LastActive">{{merchant.LastActive}}</span>
                                </td>
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                <span class="ui-resizable-column">
                                    {{merchant[item.field]}}
                                </span>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <span class="action-icon-svg" (click)="openDetailMartPartnerSideBar(merchant)">
                            <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                        </span>
                        <span class="action-icon-svg" (click)="openSuspendPartnerPopup(merchant)">
                            <img src="../Content/xpress-app/images/svg/icon_suspend.svg" />
                        </span>
                        <span class="action-icon-svg" (click)="openChatSideBar(merchant)">
                            <div class="red-circle" *ngIf="!merchant.ChatIsReaded"></div>
                            <img src="/XpressApp/assets/images/chat.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="merchants.length > 0">
                    Showing {{first + 1}} to {{first + merchants.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>

</div>

